export default __webpack_public_path__ + "static/media/Íconos 01.e04c878f.png";